/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_DeletedInputs */

const en_admin_posts_deleted = /** @type {(inputs: Admin_Posts_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post deleted`)
};

const zh_admin_posts_deleted = /** @type {(inputs: Admin_Posts_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文章已删除`)
};

/**
* | output |
* | --- |
* | "Post deleted" |
*
* @param {Admin_Posts_DeletedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_deleted = /** @type {((inputs?: Admin_Posts_DeletedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_DeletedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_deleted(inputs)
	return zh_admin_posts_deleted(inputs)
});
export { admin_posts_deleted as "admin.posts.deleted" }